import * as __glob_0 from './../article-card-hover.ts';
import * as __glob_1 from './../article-filters.ts';
import * as __glob_2 from './../blur-text.ts';
import * as __glob_3 from './../button-hover-icon.ts';
import * as __glob_4 from './../careers-timeline.ts';
import * as __glob_5 from './../casestudy-card.ts';
import * as __glob_6 from './../citation-sliders.ts';
import * as __glob_7 from './../complex-casetudy.ts';
import * as __glob_8 from './../custom-cursor.ts';
import * as __glob_9 from './../cycle.ts';
import * as __glob_10 from './../directional-list.ts';
import * as __glob_11 from './../fade-in.ts';
import * as __glob_12 from './../form.ts';
import * as __glob_13 from './../home-hero.ts';
import * as __glob_14 from './../home-news-hover.ts';
import * as __glob_15 from './../home-visionaries-card.ts';
import * as __glob_16 from './../image-cards-hover.ts';
import * as __glob_17 from './../lightbox.ts';
import * as __glob_18 from './../manual-sliders.ts';
import * as __glob_19 from './../marquee.ts';
import * as __glob_20 from './../menu.ts';
import * as __glob_21 from './../mosaic-layout.ts';
import * as __glob_22 from './../nav.ts';
import * as __glob_23 from './../news-share-links.ts';
import * as __glob_24 from './../parallax-old.ts';
import * as __glob_25 from './../parallax.ts';
import * as __glob_26 from './../pixel-grid.ts';
import * as __glob_27 from './../services-spy-scroll.ts';
import * as __glob_28 from './../services-works.ts';
import * as __glob_29 from './../small-cta-card.ts';
import * as __glob_30 from './../stagger-cards.ts';
import * as __glob_31 from './../stagger-text.ts';
import * as __glob_32 from './../team-grid.ts';
import * as __glob_33 from './../team-members.ts';
import * as __glob_34 from './../test copy.ts';
import * as __glob_35 from './../test.ts';
import * as __glob_36 from './../testimonials.ts';
import * as __glob_37 from './../vision-path.ts';
import * as __glob_38 from './../visionaries-timeline.ts';
import * as __glob_39 from './../work-filters.ts';
import * as __glob_40 from './../work-tabs.ts';
import {
  setCurrentComponentElement,
  clearCurrentComponentElement,
} from "./runner";

const modules = { "./../article-card-hover.ts": __glob_0, "./../article-filters.ts": __glob_1, "./../blur-text.ts": __glob_2, "./../button-hover-icon.ts": __glob_3, "./../careers-timeline.ts": __glob_4, "./../casestudy-card.ts": __glob_5, "./../citation-sliders.ts": __glob_6, "./../complex-casetudy.ts": __glob_7, "./../custom-cursor.ts": __glob_8, "./../cycle.ts": __glob_9, "./../directional-list.ts": __glob_10, "./../fade-in.ts": __glob_11, "./../form.ts": __glob_12, "./../home-hero.ts": __glob_13, "./../home-news-hover.ts": __glob_14, "./../home-visionaries-card.ts": __glob_15, "./../image-cards-hover.ts": __glob_16, "./../lightbox.ts": __glob_17, "./../manual-sliders.ts": __glob_18, "./../marquee.ts": __glob_19, "./../menu.ts": __glob_20, "./../mosaic-layout.ts": __glob_21, "./../nav.ts": __glob_22, "./../news-share-links.ts": __glob_23, "./../parallax-old.ts": __glob_24, "./../parallax.ts": __glob_25, "./../pixel-grid.ts": __glob_26, "./../services-spy-scroll.ts": __glob_27, "./../services-works.ts": __glob_28, "./../small-cta-card.ts": __glob_29, "./../stagger-cards.ts": __glob_30, "./../stagger-text.ts": __glob_31, "./../team-grid.ts": __glob_32, "./../team-members.ts": __glob_33, "./../test copy.ts": __glob_34, "./../test.ts": __glob_35, "./../testimonials.ts": __glob_36, "./../vision-path.ts": __glob_37, "./../visionaries-timeline.ts": __glob_38, "./../work-filters.ts": __glob_39, "./../work-tabs.ts": __glob_40 };
// console.log("modules -> []", modules);

export function createCycles(
  dataAttribute = "module",
  scopeContainer?: Element | HTMLElement
) {
  const searchRoot = scopeContainer || document;
  return Array.from(searchRoot.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const attributeValue = (element as HTMLElement).dataset[dataAttribute];

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Check if component is already initialized
            const htmlElement = element as HTMLElement;
            if (htmlElement.hasAttribute("data-initialized")) {
              return null; // Skip already initialized components
            }

            // Set the current component element context
            setCurrentComponentElement(htmlElement);

            const result = moduleFn(htmlElement, htmlElement.dataset);

            // Mark component as initialized
            htmlElement.setAttribute("data-initialized", "true");

            // Clear the context after component initialization
            clearCurrentComponentElement();

            return result;
          } catch (error) {
            // Clear context on error too
            clearCurrentComponentElement();
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}
